import { translate as t } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import React from 'react';
import { useBlinkContextForAdmin } from "../../contexts/admin-blink-context";
import { AdminContext, useAdminContext } from "../../contexts/context";
class ErrorBoundaryClass extends React.Component {
    constructor(props) {
        super(props);
        this.onClickBackToHome = () => {
            this.props.onGoRootPath();
            window.location.reload();
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
    }
    render() {
        if (this.state.hasError) {
            return (React.createElement(Vertical, { hAlignContent: "center", vAlignContent: "center", height: 500 },
                React.createElement("h2", null,
                    React.createElement(Icon, { size: IconSize.LARGE, id: IconID.EXCLAMATION_POINT_CIRCLE }),
                    "\u00A0 ",
                    t('error.validation.default')),
                React.createElement(Button, { onClick: this.onClickBackToHome, size: "m", type: "primary", text: t('GoToHomepage') })));
        }
        return this.props.children;
    }
}
ErrorBoundaryClass.contextType = AdminContext;
export const ErrorBoundary = ({ children, }) => {
    const { navService } = useBlinkContextForAdmin();
    const adminContext = useAdminContext();
    const onGoRootPath = () => {
        navService?.goToPath(`#${adminContext?.rootPath}`, {
            forceFullPageLoad: true,
        });
    };
    return (React.createElement(ErrorBoundaryClass, { onGoRootPath: onGoRootPath }, children));
};
//# sourceMappingURL=error-boundary.container.js.map